import React from 'react';

import Table from '../../../../common/filterTable/components/Table';
import CardList from '../../../../common/layout/Card/CardList';
import { DivideLine } from '../../../../components/Layout';
import { EnumOperationType } from '../../../../enum/EnumOperationType';
import { useTranslation } from '../../../../hooks';
import { useAppSelector } from '../../../../reducer/hooks';
import { selectIsMobileView } from '../../../../reducer/mediaSlice';
import useSwapDetailsExactGetTable from './helpers/useSwapDetailsExactGetTable';
import useSwapDetailsExactPayTable from './helpers/useSwapDetailsExactPayTable';
import useTransactionOperationTableColumns from './helpers/useTransactionOperationTableColumns';
import useTransactionOperationTableRows from './helpers/useTransactionOperationTableRows';
import { ExecutionType } from './types/OperationDetailsRequestBody';
import {
  TransactionOperationTableColumnKey,
  TransactionOperationTableRow,
} from './types/TransactionOperationTable';

interface IProps {
  selectedRow: TransactionOperationTableRow;
}

const ApproveRejectContent = (props: IProps) => {
  const { selectedRow } = props;
  const { t, translate } = useTranslation('transactionRequest');
  const isMobile = useAppSelector(selectIsMobileView);

  const transactionOperations = selectedRow.rawData?.transactionOperations || [];
  const operationDetails = JSON.parse(selectedRow.rawData?.requestBody || '{}')?.operations || {};

  const { rows, totalCounts } = useTransactionOperationTableRows({
    apiList: transactionOperations,
  });
  const columns = useTransactionOperationTableColumns();

  const { exactGetColumns, exactGetRows } = useSwapDetailsExactGetTable({ operationDetails });
  const { exactPayColumns, exactPayRows } = useSwapDetailsExactPayTable({ operationDetails });

  const isUniSwap = selectedRow.rawData?.operationType === EnumOperationType.Uniswap;
  const isExactGet =
    operationDetails[0].execution_detail?.execution_type === ExecutionType.ExactGet;

  const swapDetailsColumns = isExactGet ? exactGetColumns : exactPayColumns;
  const swapDetailsRows = isExactGet ? exactGetRows : exactPayRows;

  if (isMobile) {
    return (
      <>
        {/* Mobile */}
        {isUniSwap && (
          <>
            <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
              <h3>{t('swapDetails')}</h3>
              <CardList rows={swapDetailsRows} columns={swapDetailsColumns} />
              <DivideLine verticalMargin="32px" />
            </div>
          </>
        )}
        <h3>{t('operations')}</h3>
        <CardList rows={rows} columns={columns} />
      </>
    );
  }

  return (
    <>
      {/* Swap Details Table */}
      {isUniSwap && (
        <div style={{ marginBottom: '60px', maxHeight: '70vh', overflow: 'auto' }}>
          <h3>{t('swapDetails')}</h3>
          <Table
            columns={swapDetailsColumns}
            rows={swapDetailsRows}
            rowCount={swapDetailsRows.length}
            page={1}
            onPageChange={() => {}}
            // sort by operationSeq
            sortModel={[
              { field: TransactionOperationTableColumnKey.OperationSequence, sort: 'asc' },
            ]}
            hideFooter
            hideFooterPagination
          />
        </div>
      )}

      {/* Operations Table */}
      <div style={{ maxHeight: '70vh', overflow: 'auto' }}>
        <h3>{t('operations')}</h3>
        <Table
          columns={columns}
          rows={rows}
          rowCount={totalCounts}
          page={1}
          onPageChange={() => {}}
          // sort by operationSeq
          sortModel={[
            { field: TransactionOperationTableColumnKey.OperationSequence, sort: 'desc' },
          ]}
          hideFooter
          hideFooterPagination
        />
      </div>
    </>
  );
};

export default ApproveRejectContent;
